module.exports = __webpack_public_path__ + "img/7.9595a522.png";